(() => {
	// Mobil sinir: bu degerin altinda karusel (Swiper), ustunde CSS grid calisir.
	// CSS tarafindaki @media (min-width: 750px) ile uyumlu kalmali.
	const mobileQuery = "(max-width: 749px)";

	const initSlider = (section) => {
		let bannerSlider;

		if (document.currentScript) {
			bannerSlider = document.currentScript.parentElement.querySelectorAll(
				".js-slider-banner-slider"
			);
		} else {
			bannerSlider = section.querySelectorAll(".js-slider-banner-slider");
		}

		const isMobile = window.matchMedia(mobileQuery).matches;

		if (bannerSlider && bannerSlider.length > 0) {
			bannerSlider.forEach((el) => {
				// Masaustunde Swiper kurulmaz; varsa yok edilir ve CSS grid devreye girer.
				if (!isMobile) {
					if (el.swiper) el.swiper.destroy(true, true);
					return;
				}

				const speed1 = el.getAttribute("data-duration");
				const mobileColumnCount =
					Number(el.getAttribute("data-mobile-column-count")) || 1;
				const prevBtn = section.querySelector(".swiper-button-prev");
				const nextBtn = section.querySelector(".swiper-button-next");

				new Swiper(el, {
					// Mobil sutun sayisi panelden gelir (data-mobile-column-count).
					slidesPerView: mobileColumnCount,
					spaceBetween: 12,
					autoplay: false,
					direction: "horizontal",
					loop: false,
					speed: speed1,
					shortSwipes: true,
					longSwipes: false,
					allowTouchMove: true,
					navigation:
						prevBtn && nextBtn ? { nextEl: nextBtn, prevEl: prevBtn } : false,
					mousewheel: {
						forceToAxis: true,
					},
				});
			});
		}
	};

	const initSection = (section) => {
		let sectionBanner;

		if (document.currentScript) {
			sectionBanner = document.currentScript.parentElement;
		} else {
			sectionBanner = section;
		}

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			const sliders = entry.target.querySelectorAll(".js-slider-banner-slider");
			const slidersSlow = entry.target.querySelectorAll(
				".js-slider-banner-slider-slow"
			);

			if (sliders.length != 0) {
				sliders.forEach((slider) => {
					if (slider.swiper) slider.swiper.destroy();
				});
			}

			if (slidersSlow.length != 0) {
				slidersSlow.forEach((slider) => {
					if (slider.swiper) slider.swiper.destroy();
				});
			}

			initSlider(sectionBanner);
		});

		initSlider(sectionBanner);

		sectionResizeObserver.observe(sectionBanner);
	};

	initSection();

	document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
	});
})();